import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'
import LookupLink from 'Components/LookupLink'
import {
  SECONDARY_NORMAL_COLOR,
  TEXT_GREY,
  PRIMARY_NORMAL_COLOR,
  CLICKABLE_COLOR,
} from '@CSSVars/colors'

export const _AgentPreview = styled(Col)`
  padding-right: 5px;
  padding-left: 5px;
  @media screen and (max-width: 47.9em) {
    flex-basis: 50%;
    max-width: 50%;
  }
`
export const _Name = styled.h2`
  font-size: 16px;
  line-height: 22px;
  text-transform: uppercase;
  text-align: center;
  color: ${CLICKABLE_COLOR};
  transition: all 0.3s;
  text-decoration: underline;
  @media screen and (max-width: 47.9em) {
    font-size: 15px;
  }

`
export const _Content = styled.div`
  position: relative;
  background-color: white;
  margin-bottom: 1em;
  &:hover,
  &:focus {
    h2 {
      color: ${PRIMARY_NORMAL_COLOR};
    }
  }
`

export const _BoxLink = styled(LookupLink)`
  text-decoration: none;
`

export const _PreviewContainer = styled.div`
  background-color: ${SECONDARY_NORMAL_COLOR};
  min-height: 90px;
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
    display: block;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);
  }
`

export const _InfoContainer = styled.div`
  padding: 2em 0;
  @media screen and (max-width: 63.9em) {
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

export const _Position = styled.h3`
  text-align: center;
  font-size: 12px;
  line-height: 22px;
  color: ${TEXT_GREY};
  margin-top: 3px;
  @media screen and (max-width: 63.9em) {
   font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  @media screen and (max-width: 47.9em) {
    font-size: 12px;
  }
  @media screen and (max-width: 29.9em) {
    font-size: 10px;
  }
`

export const _AgentBrokerageName = styled.div`
  margin-bottom: 3px;
  color: ${TEXT_GREY};
  font-size: 12px;
  line-height: 22px;
  text-align: center;
`
